export default __webpack_public_path__ + "static/media/rocket_anim_49.09f21808.png";